import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'
import QRCodeReact from 'qrcode.react'

const QRCode = ({ url, size }) => <QRCodeReact value={url} size={size} />

QRCode.propTypes = {
  url: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired
}

export default compose(pure)(QRCode)
